import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation } from "react-router";
import { useSession } from "../api/hooks";

/** Gate for every route except /signin: asks GET /api/session once and redirects on 401. */
export function RequireAuth() {
  const { t } = useTranslation("common");
  const session = useSession();
  const location = useLocation();
  if (session.isPending) {
    return <p className="p-6 text-ink-3">{t("loading")}</p>;
  }
  if (session.isError || !session.data?.authenticated) {
    return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
